<template>
  <aside class="internal-configurations-sidebar">
    <slot />

    <div
      v-if="$slots.footer"
      class="footer-wrapper"
    >
      <slot name="footer" />
    </div>
  </aside>
</template>

<style scoped lang="scss">
.internal-configurations-sidebar {
  --f7-button-height: 48px;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  box-sizing: border-box;
  gap: 6px;
  height: 100%;
  border-right: 1px solid #ccc;
  padding: 8px;

  :deep(.button) {
    width: 100%;
    justify-content: flex-start;
  }

  .footer-wrapper {
    width: 100%;
    margin-top: auto;
  }
}
</style>
